// import Select from "@mui/material/Select";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";

// import React, { useEffect, useState } from "react";
// import Box from "@mui/material/Box";
// import Grid from "@mui/material/Grid";
// import { useAuth } from "../../context/AuthContext";
// import Backdrop from "@mui/material/Backdrop";

// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";
// import Typography from "@mui/material/Typography";
// import { TextField } from "@mui/material";
// import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
// import { useNavigate } from "react-router-dom";
// import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
// import { useTranslation } from "react-i18next";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";

// import FormLabel from "@mui/material/FormLabel";

// import {
//   db,
//   collection,
//   query,
//   doc,
//   getDocs,
//   setDoc,
//   getDoc,
//   addDoc,
//   updateDoc,
// } from "../../firebase";
// import AdminLeftMenu from "./AdminLeftMenu";
// import { useParams } from "react-router-dom";
// import AdminSentEmailsFromOrder from "./AdminSentEmailsFromOrder";
// import { functions, httpsCallable } from "../../firebase";
// import AdminCheck from "./AdminCheck";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   minWidth: 600,
//   bgcolor: "background.paper",
//   boxShadow: 24,
//   p: 4,
// };

// const AdminDashboard = () => {
//   let { id } = useParams();
//   const { t, i18n } = useTranslation();
//   let navigate = useNavigate();

//   const [orders, setOrders] = useState([]);
//   const [order, setOrder] = useState(null);
//   const [step, setStep] = useState(2);

//   const [open, setOpen] = React.useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   const [shipMethod1, setShipMethod1] = useState(null);
//   const [shipMethod2, setShipMethod2] = useState(null);

//   const [shipNum1, setShipNum1] = useState(null);
//   const [shipNum2, setShipNum2] = useState(null);

//   const [status, setStatus] = useState(null);
//   const [reason, setReason] = useState(null);
//   const [tracker, setTracker] = useState(null);

//   const easyPostRetrieveTracker = httpsCallable(
//     functions,
//     "easyPostRetrieveTracker"
//   );

//   const getOrders = async () => {
//     setOrders([]);
//     const docRef = doc(db, "orders", id);
//     const docSnap = await getDoc(docRef);
//     setStatus(docSnap.data().status);
//     setOrder(docSnap.data());
//     console.log(
//       "docSnap.data().shipment.tracker_id ",
//       docSnap.data().shipment.tracker_id
//     );
//     easyPostRetrieveTracker({ id: docSnap.data().shipment.tracker_id })
//       .then((result) => {
//         console.log(result);
//         setTracker(result);
//       })
//       .catch((error) => console.log(error));

//     if (docSnap.exists()) {
//       const docRef2 = doc(db, "users", docSnap.data().user_uid);
//       getDoc(docRef2).then(async (res) => {
//         console.log(res.data());
//         if (res.data().firstname && res.data().lastname) {
//           setOrders((old) =>
//             old.concat({
//               ...docSnap.data(),
//               id: docSnap.data().id,
//               firstname: res.data().firstname,
//               lastname: res.data().lastname,
//               phone: res.data().phone,
//             })
//           );
//         } else {
//           setOrders((old) =>
//             old.concat({
//               ...docSnap.data(),
//               id: docSnap.data().id,
//               phone: res.data().phone,
//             })
//           );
//         }
//       });
//     } else {
//       navigate("/admin/orders");
//     }
//   };

//   useEffect(() => {
//     setTimeout(() => {
//       getOrders();
//     }, 100);
//   }, []);

//   console.log(orders);

//   console.log(step);
//   console.log("status", status); // selected action
//   console.log("order.status", order?.status);

//   useEffect(() => {
//     setStep(1);
//   }, []);

//   const changeStep = (num) => {
//     setStep(num);
//   };

//   const orderConfirmed = async (orderId) => {
//     try {
//       const ref = doc(db, "orders", orderId);

//       await updateDoc(
//         ref,
//         {
//           status: [...order.status, "Order confirmed"],
//         },
//         { merge: true }
//       );

//       await addDoc(collection(db, "mail"), {
//         to: order.email,
//         orderNumber: orderId,
//         message: {
//           subject: "Heslet - Order confirmed",
//           html: `<!DOCTYPE html>
//         <html lang="en">
//         <head>
//             <meta charset="UTF-8">
//             <meta http-equiv="X-UA-Compatible" content="IE=edge">
//             <meta name="viewport" content="width=device-width, initial-scale=1.0">
//             <title>Thank you!</title><style>
//                 @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
//                 .myDiv {
//                     font-family: 'Roboto', sans-serif;
//                   border: 1px solid lightgray;
//                   width:400px;
//                  margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
//                  padding-left:20px; padding-right:20px; line-height: 1.8em;
//                 }
//                 .logo{display:flex;  justify-content: space-between;}
//                 .confirm{top:+40px;position:relative}
//                 .blue{color:#153a5a; font-weight: bold;}
//                 .hello{padding-top:30px}
//                 .detail{padding-top:30px;border-bottom:1px solid lightgray;}
//                 .order{padding-top:20px}
//                 .green{color:#689f38}
//                 .custom_btn{background-color: #153a5b;cursor:pointer;
//           color: white;
//           letter-spacing: 3px;
//           border-radius: 0;
//           width: 100%;
//           border: none;
//           text-transform: uppercase;
//           padding-top: 15px;
//           padding-bottom: 15px;
//           cursor: pointer;}
//             .button{padding-top:20px}
//             .ship{padding-top:20px}
//             .Recommendations{padding-top:40px}
//             .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
//             .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
//             justify-content: space-evenly;}
//             .custom_btn_whitebg {
//           border: 1px #212a2f solid;
//           color: black;
//           letter-spacing: 3px;
//           border-radius: 0;
//           width: 100%;
//           border: none;
//           text-transform: uppercase;
//           padding-top: 15px;
//           padding-bottom: 15px;
//           cursor: pointer;
//         }
//               </style>
//         </head>
//         <body>
//             <div class="myDiv">
//                 <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
//                 <div class="confirm" style="padding-top:50px; padding-left:30px;">Heslet - Order Confirmed</div></div>
//                 <br />
//                 <div class="blue hello">Hello ${order.address_firstname},</div>
//                 <br />Thank you for purchasing at Heslet.com. Your order has confirmed. We are preparing for the shipment. Thank you.
//                 <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn">our products</button></a></div>
//                 <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn_whitebg">Our Technology</button></a></div>
//                 <div class="Recommendations">
//                      Recommendations for items from across our store
//                 </div>
//                 <div class="recomm">
//                     <div class="each" style="padding-right:30px;">
//                         <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
//                         <div>Premium Heavy Duty<br /> Hand Wipes</div>
//                     </div>
//                     <div class="each" style="padding-right:30px;">
//                         <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
//                         <div>Premium<br /> All-Purpose Wipes</div>
//                     </div>
//                     <div class="each">
//                         <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
//                         <div>Premium <br />All Purpose Spray</div>
//                     </div>
//                 </div>
//                 <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
//             </div>
//         </body>
//         </html>`,
//         },
//       });
//       changeStep(3);
//       setTimeout(() => {
//         handleClose();
//         changeStep(1);
//         window.location.reload(false);
//       }, 2000);
//     } catch (err) {}
//   };

//   const orderDelayed = async (orderId) => {
//     try {
//       const ref = doc(db, "orders", orderId);
//       await updateDoc(
//         ref,
//         {
//           status: [...order.status, "Order delayed"],
//         },
//         { merge: true }
//       );

//       await addDoc(collection(db, "mail"), {
//         to: order.email,
//         orderNumber: order.id,
//         message: {
//           subject: "Heslet - Order delayed",
//           html: `<!DOCTYPE html>
//         <html lang="en">
//         <head>
//             <meta charset="UTF-8">
//             <meta http-equiv="X-UA-Compatible" content="IE=edge">
//             <meta name="viewport" content="width=device-width, initial-scale=1.0">
//             <title>Thank you!</title><style>
//                 @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
//                 .myDiv {
//                     font-family: 'Roboto', sans-serif;
//                   border: 1px solid lightgray;
//                   width:400px;
//                  margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
//                  padding-left:20px; padding-right:20px; line-height: 1.8em;
//                 }
//                 .logo{display:flex;  justify-content: space-between;}
//                 .confirm{top:+40px;position:relative}
//                 .blue{color:#153a5a; font-weight: bold;}
//                 .hello{padding-top:30px}
//                 .detail{padding-top:30px;border-bottom:1px solid lightgray;}
//                 .order{padding-top:20px}
//                 .green{color:#689f38}
//                 .custom_btn{background-color: #153a5b;cursor:pointer;
//           color: white;
//           letter-spacing: 3px;
//           border-radius: 0;
//           width: 100%;
//           border: none;
//           text-transform: uppercase;
//           padding-top: 15px;
//           padding-bottom: 15px;
//           cursor: pointer;}
//             .button{padding-top:20px}
//             .ship{padding-top:20px}
//             .Recommendations{padding-top:40px}
//             .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
//             .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
//             justify-content: space-evenly;}
//             .custom_btn_whitebg {
//           border: 1px #212a2f solid;
//           color: black;
//           letter-spacing: 3px;
//           border-radius: 0;
//           width: 100%;
//           border: none;
//           text-transform: uppercase;
//           padding-top: 15px;
//           padding-bottom: 15px;
//           cursor: pointer;
//         }
//               </style>
//         </head>
//         <body>
//             <div class="myDiv">
//                 <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
//                 <div class="confirm" style="padding-top:50px; padding-left:30px;">Heslet - Order Delayed</div></div>
//                 <br />
//                 <div class="blue hello">Hello ${order.address_firstname},</div>
//                 <br />We are so sorry. Your order has delayed.
//               sssss
//                 <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn">our products</button></a></div>
//                 <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn_whitebg">Our Technology</button></a></div>
//                 <div class="Recommendations">
//                      Recommendations for items from across our store
//                 </div>
//                 <div class="recomm">
//                     <div class="each" style="padding-right:30px;">
//                         <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
//                         <div>Premium Heavy Duty<br /> Hand Wipes</div>
//                     </div>
//                     <div class="each" style="padding-right:30px;">
//                         <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
//                         <div>Premium<br /> All-Purpose Wipes</div>
//                     </div>
//                     <div class="each">
//                         <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
//                         <div>Premium <br />All Purpose Spray</div>
//                     </div>
//                 </div>
//                 <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
//             </div>
//         </body>
//         </html>`,
//         },
//       });
//     } catch (err) {
//       alert("There is an error when processing. Please try again later.");
//     }
//   };
//   const orderCancelled = async (orderId, sendEmail) => {
//     try {
//       const ref = doc(db, "orders", orderId);
//       await updateDoc(
//         ref,
//         {
//           status: [...order.status, "Order cancelled"],
//         },
//         { merge: true }
//       );
//       await addDoc(collection(db, "mail"), {
//         to: orders[0].email,
//         message: {
//           subject: "Your Helset order #" + id + " has cancelled.",
//           html: `<!DOCTYPE html>
//               <html lang="en">
//               <head>
//                   <meta charset="UTF-8">
//                   <meta http-equiv="X-UA-Compatible" content="IE=edge">
//                   <meta name="viewport" content="width=device-width, initial-scale=1.0">
//                   <title>Thank you!</title><style>
//                       @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
//                       .myDiv {
//                           font-family: 'Roboto', sans-serif;
//                         border: 1px solid lightgray;
//                         width:400px;
//                        margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
//                        padding-left:20px; padding-right:20px; line-height: 1.8em;
//                       }
//                       .logo{display:flex;  justify-content: space-between;}
//                       .confirm{top:+40px;position:relative}
//                       .blue{color:#153a5a; font-weight: bold;}
//                       .hello{padding-top:30px}
//                       .detail{padding-top:30px;border-bottom:1px solid lightgray;}
//                       .order{padding-top:20px}
//                       .green{color:#689f38}
//                       .custom_btn{background-color: #153a5b;
//                 color: white;
//                 letter-spacing: 3px;
//                 border-radius: 0;
//                 width: 100%;
//                 border: none;
//                 text-transform: uppercase;
//                 padding-top: 15px;
//                 padding-bottom: 15px;
//                 cursor: pointer;}
//                   .button{padding-top:20px}
//                   .ship{padding-top:20px}
//                   .Recommendations{padding-top:20px}
//                   .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
//                   .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
//                   justify-content: space-evenly;}
//                   .custom_btn_whitebg {
//                 border: 1px #212a2f solid;
//                 color: black;
//                 letter-spacing: 3px;
//                 border-radius: 0;
//                 width: 100%;
//                 border: none;
//                 text-transform: uppercase;
//                 padding-top: 15px;
//                 padding-bottom: 15px;
//                 cursor: pointer;
//               }
//                     </style>
//               </head>
//               <body>
//                   <!-- Your Amazon.com order #111-1689550-3191433 has shipped -->
//                   <div class="myDiv">
//                       <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
//                       <div  style="top:+40px;position:relative; padding-left:20px; font-size:27px;padding-top:40px;">Heslet LLC</div></div>
//                       <br />
//                       <div class="blue hello">Hello ${
//                         orders[0]?.firstname
//                       },</div>
//                       <br />We are sorry. Your order has cancelled. <br />We are currently processing your refund. It will take 5-10 business day to get refund.
//                       <br />
//                       The refund will goes to your original payment method.
//                       <br />If you have any questions, contact us at 1-800-383-4942.

//                       <div class="button"><a href="${
//                         window.location.hostname + "/dashboard"
//                       }"><button class="custom_btn_whitebg">View Order History</button></a></div>

//                       <div style="padding-top:20px;">
//                           <div style="color:gray">REFUND TOTAL</div>
//                           <div>$${orders[0].finalPrice}</div>
//                       </div>
//                       <div style="padding-top:20px;">
//                           <div style="color:gray">If you have a problem with your order, contact us.</div>
//                       </div>
//                       <div class="Recommendations">
//                            Recommendations for items from across our store
//                       </div>
//                       <div class="recomm">
//                         <div class="each" style="padding-right:30px;">
//                             <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
//                             <div>Premium Heavy Duty<br /> Hand Wipes</div>
//                         </div>
//                         <div class="each" style="padding-right:30px;">
//                             <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
//                             <div>Premium<br /> All-Purpose Wipes</div>
//                         </div>
//                         <div class="each">
//                             <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
//                             <div>Premium <br />All Purpose Spray</div>
//                         </div>
//                     </div>
//                       <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
//                   </div>
//               </body>
//               </html>`,
//         },
//       });
//       changeStep(3);
//       setTimeout(() => {
//         handleClose();
//         changeStep(1);
//       }, 2000);
//       window.location.reload(false);
//     } catch (error) {
//       alert("There is an error when processing. Please try again later.");
//     }
//   };

//   const orderShipped = async (orderId) => {
//     try {
//       const ref = doc(db, "orders", orderId);
//       await updateDoc(
//         ref,
//         {
//           status: [...order.status, "Order shipped"],
//         },
//         { merge: true }
//       );
//       await addDoc(collection(db, "mail"), {
//         to: orders[0].email,
//         message: {
//           subject: "Your Helset order #" + id + " has shipped.",
//           html: `<!DOCTYPE html>
//               <html lang="en">
//               <head>
//                   <meta charset="UTF-8">
//                   <meta http-equiv="X-UA-Compatible" content="IE=edge">
//                   <meta name="viewport" content="width=device-width, initial-scale=1.0">
//                   <title>Thank you!</title><style>
//                       @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
//                       .myDiv {
//                           font-family: 'Roboto', sans-serif;
//                         border: 1px solid lightgray;
//                         width:400px;
//                        margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
//                        padding-left:20px; padding-right:20px; line-height: 1.8em;
//                       }
//                       .logo{display:flex;  justify-content: space-between;}
//                       .confirm{top:+40px;position:relative}
//                       .blue{color:#153a5a; font-weight: bold;}
//                       .hello{padding-top:30px}
//                       .detail{padding-top:30px;border-bottom:1px solid lightgray;}
//                       .order{padding-top:20px}
//                       .green{color:#689f38}
//                       .custom_btn{background-color: #153a5b;
//                 color: white;
//                 letter-spacing: 3px;
//                 border-radius: 0;
//                 width: 100%;
//                 border: none;
//                 text-transform: uppercase;
//                 padding-top: 15px;
//                 padding-bottom: 15px;
//                 cursor: pointer;}
//                   .button{padding-top:20px}
//                   .ship{padding-top:20px}
//                   .Recommendations{padding-top:20px}
//                   .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
//                   .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
//                   justify-content: space-evenly;}
//                   .custom_btn_whitebg {
//                 border: 1px #212a2f solid;
//                 color: black;
//                 letter-spacing: 3px;
//                 border-radius: 0;
//                 width: 100%;
//                 border: none;
//                 text-transform: uppercase;
//                 padding-top: 15px;
//                 padding-bottom: 15px;
//                 cursor: pointer;
//               }
//                     </style>
//               </head>
//               <body>
//                   <!-- Your Amazon.com order #111-1689550-3191433 has shipped -->
//                   <div class="myDiv">
//                       <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
//                       <div  style="top:+40px;position:relative; padding-left:20px; font-size:27px;padding-top:40px;">Heslet LLC</div></div>
//                       <br />
//                       <div class="blue hello">Hello ${
//                         orders[0]?.firstname
//                       },</div>
//                       <br />We are sorry. Your order has cancelled. <br />We are currently processing your refund. It will take 5-10 business day to get refund.
//                       <br />
//                       The refund will goes to your original payment method.
//                       <br />If you have any questions, contact us at 1-800-383-4942.

//                       <div class="button"><a href="${
//                         window.location.hostname + "/dashboard"
//                       }"><button class="custom_btn_whitebg">View Order History</button></a></div>

//                       <div style="padding-top:20px;">
//                           <div style="color:gray">REFUND TOTAL</div>
//                           <div>$${orders[0].finalPrice}</div>
//                       </div>
//                       <div style="padding-top:20px;">
//                           <div style="color:gray">If you have a problem with your order, contact us.</div>
//                       </div>
//                       <div class="Recommendations">
//                            Recommendations for items from across our store
//                       </div>
//                       <div class="recomm">
//                         <div class="each" style="padding-right:30px;">
//                             <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
//                             <div>Premium Heavy Duty<br /> Hand Wipes</div>
//                         </div>
//                         <div class="each" style="padding-right:30px;">
//                             <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
//                             <div>Premium<br /> All-Purpose Wipes</div>
//                         </div>
//                         <div class="each">
//                             <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
//                             <div>Premium <br />All Purpose Spray</div>
//                         </div>
//                     </div>
//                       <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
//                   </div>
//               </body>
//               </html>`,
//         },
//       });
//       changeStep(3);
//       setTimeout(() => {
//         handleClose();
//         changeStep(1);
//       }, 2000);
//       window.location.reload(false);
//     } catch (error) {
//       alert("There is an error when processing. Please try again later.");
//     }
//   };

//   const updateShippingInfo = async () => {
//     // 발주확인
//     if (status === "Order confirmed") {
//       orderConfirmed(id);
//     } else if (status === "Order delayed") {
//       orderDelayed(id);
//     } else if (status === "Order cancelled") {
//       orderCancelled(id);
//     } else {
//       orderShipped(id);
//     }
//     getOrders();
//   };

//   return (
//     <Grid container>
//       <AdminCheck />
//       <AdminLeftMenu />
//       <Grid item md={9} sm={12}>
//         <Grid container>
//           {/* <Modal
//             aria-labelledby="transition-modal-title"
//             aria-describedby="transition-modal-description"
//             open={open}
//             onClose={handleClose}
//             closeAfterTransition
//             BackdropComponent={Backdrop}
//             BackdropProps={{
//               timeout: 500,
//             }}
//           >
//             <Fade in={open}>
//               <Box sx={style}>
//                 {step === 1 ? null : null}
//                 {step === 2 ? (
//                   <Box sx={{ py: 2, fontSize: "19px" }}>
//                     <Box>Confirm the shipping information</Box>
//                     <Box sx={{ color: "gray", pb: 2, fontSize: "15px", pt: 2 }}>
//                       After submitting, it will send an automatic email to the
//                       user.
//                     </Box>
//                     {shipMethod1 && (
//                       <Box>
//                         Shipping #1: {shipMethod1} - {shipNum1}
//                       </Box>
//                     )}
//                     {shipMethod2 && (
//                       <Box sx={{ pt: 3 }}>
//                         Shipping #2: {shipMethod2} - {shipNum2}
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 4 }}>
//                       <button
//                         onClick={updateShippingInfo}
//                         className="custom_btn"
//                       >
//                         Confirm
//                       </button>
//                     </Box>
//                   </Box>
//                 ) : null}
//                 {step === 3 ? (
//                   <Box>Thank you for updating shipping information.</Box>
//                 ) : null}
//               </Box>
//             </Fade>
//           </Modal> */}
//           <Grid
//             item
//             md={12}
//             sm={12}
//             xs={12}
//             sx={{ backgroundColor: "#faf9f6", minHeight: "100%" }}
//           >
//             <Box sx={{ py: 6, px: 3 }}>
//               {/* Content */}
//               <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
//                 <Box sx={{ fontSize: "22px" }}>An Order</Box>
//                 {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
//                   View Details Stats
//                 </Box> */}
//               </Box>
//               <Box
//                 sx={{
//                   mt: 2,
//                   borderRadius: "2px",
//                   display: "flex",
//                   fontSize: "14px",
//                 }}
//               ></Box>
//               <Grid container>
//                 <Grid item md={12} sm={12} xs={12} sx={{ pb: 10 }}>
//                   <Box
//                     sx={{
//                       py: 2,
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       px: 4,
//                     }}
//                   >
//                     {orders.map((order, idx) => {
//                       console.log("order", order);
//                       return (
//                         <Box
//                           key={idx}
//                           className="textBox"
//                           style={{
//                             marginBottom: "20px",
//                             width: "100%",
//                             backgroundColor: "white",
//                           }}
//                         >
//                           <Box sx={{ color: "black", fontSize: "14px" }}>
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 paddingTop: "10px",
//                                 alignItems: "center",
//                               }}
//                             ></Box>
//                           </Box>
//                           <Box>
//                             <Typography
//                               id="transition-modal-title"
//                               component={"span"}
//                               variant={"body2"}
//                               style={{ fontSize: "22px" }}
//                             >
//                               Order Detail
//                             </Typography>
//                             <Typography
//                               id="transition-modal-description"
//                               sx={{
//                                 mt: 2,
//                                 color: "black",
//                                 lineHeight: "1.9em",
//                               }}
//                             >
//                               <Box>
//                                 <span style={{}}>
//                                   {t("Order #")}: {id}
//                                 </span>
//                               </Box>
//                               <div style={{}}>
//                                 {t("Customer Name")}:&nbsp;
//                                 <span>
//                                   {order?.firstname} {order?.lastname}
//                                 </span>{" "}
//                               </div>
//                               <span>{t("Shipping Address")}: </span>
//                               {order?.address_firstname}&nbsp;
//                               {order?.address_lastname}&nbsp;
//                               {order?.address_address}&nbsp;
//                               {order?.address_apt}&nbsp;
//                               {order?.address_city}&nbsp;
//                               {order?.address_state}&nbsp;
//                               {order?.address_zipcode}
//                               <br />
//                               <span>{t("Shipping Option")}:</span>{" "}
//                               {order?.shippingOption} (
//                               <span>{t("Shipping Price")}:</span> $
//                               {order?.shippingPrice})
//                               <br />
//                               <span>{t("Final Price")}:</span> $
//                               {order?.finalPrice}
//                               <br />
//                               <Box>
//                                 {t("Current Status")}:{" "}
//                                 <span style={{ color: "blue" }}>
//                                   {order.status[order.status.length - 1]}
//                                 </span>{" "}
//                                 <Box
//                                   sx={{
//                                     fontSize: "14px",
//                                     display: "flex",
//                                     justifyContent: "space-between",

//                                     paddingBottom: "10px",
//                                     marginTop: "10px",
//                                   }}
//                                 >
//                                   <Box>
//                                     <a
//                                       href={"mailto:" + order.email}
//                                       className="pink_link"
//                                     >
//                                       {order?.firstname} {order?.lastname}
//                                     </a>{" "}
//                                     - Purchase Date:{" "}
//                                     {order?.created?.toDate().toDateString()}
//                                   </Box>
//                                   <Box
//                                     sx={{ fontSize: "13px", display: "flex" }}
//                                   >
//                                     <Box className="pink_link" sx={{ ml: 2 }}>
//                                       {order.phone}
//                                     </Box>
//                                   </Box>
//                                 </Box>
//                               </Box>
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   flexDirection: "column",
//                                   width: 1,
//                                   py: 3,
//                                   borderTop: "1px solid lightgray",
//                                   borderBottom: "1px solid lightgray",
//                                 }}
//                               >
//                                 <Box
//                                   sx={{
//                                     width: 1,
//                                     display: "flex",
//                                     alignItems: "center",
//                                   }}
//                                 >
//                                   <Box sx={{ pr: 1 }}>Shipment: </Box>
//                                   <Box>
//                                     <a
//                                       href={order?.shipment.shipmentLabel}
//                                       target="_blank"
//                                     >
//                                       <button
//                                         className="custom_btn"
//                                         style={{
//                                           width: "180px",
//                                         }}
//                                       >
//                                         Shipping Label
//                                       </button>
//                                     </a>
//                                   </Box>
//                                   <Box sx={{ ml: 1 }}>
//                                     <a
//                                       href={order?.shipment.tracker_public_url}
//                                       target="_blank"
//                                     >
//                                       <button
//                                         className="custom_btn"
//                                         style={{ width: "180px" }}
//                                       >
//                                         Tracker
//                                       </button>
//                                     </a>
//                                   </Box>
//                                 </Box>
//                                 <Box sx={{ pt: 2 }}>
//                                   Shipping Status:{" "}
//                                   <span className="pink_link">
//                                     {tracker?.data.status}
//                                   </span>
//                                 </Box>
//                               </Box>
//                               <Box
//                                 sx={{
//                                   fontSize: "14px",
//                                   pt: 2,
//                                   color: "#757575",
//                                   display: "flex",
//                                   justifyContent: "space-between",
//                                   flex: 1,
//                                 }}
//                               >
//                                 <Box>
//                                   {JSON.parse(order.basket).map((item, idx) => (
//                                     <Box key={idx} sx={{ color: "black" }}>
//                                       <Box
//                                         sx={{
//                                           display: "flex",
//                                           alignItems: "center",
//                                         }}
//                                       >
//                                         <img
//                                           src={item.image}
//                                           alt=""
//                                           width="100"
//                                         />
//                                         <Box>
//                                           {item.quantity}x {item.name}
//                                         </Box>
//                                       </Box>
//                                     </Box>
//                                   ))}
//                                 </Box>
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     minWidth: "200px",
//                                   }}
//                                 >
//                                   <Box
//                                     sx={{
//                                       fontSize: "14px",
//                                       color: "black",
//                                       pb: 2,
//                                     }}
//                                   >
//                                     $ {order.finalPrice}
//                                   </Box>
//                                   <Box
//                                     sx={{
//                                       display: "flex",
//                                       justifyContent: "space-between",
//                                     }}
//                                   >
//                                     <Box>Subtotal</Box>
//                                     <Box>$ {order.subtotal}</Box>
//                                   </Box>
//                                   <Box
//                                     sx={{
//                                       display: "flex",
//                                       justifyContent: "space-between",
//                                       pb: 1,
//                                     }}
//                                   >
//                                     <Box>Shipping</Box>
//                                     <Box>$ {order.shippingPrice}</Box>
//                                   </Box>

//                                   <Box
//                                     sx={{
//                                       borderTop: "1px solid lightgray",
//                                       pt: 1,
//                                     }}
//                                   ></Box>
//                                   <Box
//                                     sx={{
//                                       display: "flex",
//                                       justifyContent: "space-between",
//                                     }}
//                                   >
//                                     <Box>Total</Box>
//                                     <Box>$ {order.finalPrice}</Box>
//                                   </Box>
//                                 </Box>
//                               </Box>
//                               <Box sx={{ pt: 2 }}>
//                                 <InventoryOutlinedIcon
//                                   sx={{ position: "relative", top: "+6px" }}
//                                 />{" "}
//                                 {order.status[order.status.length - 1] ===
//                                 "Order cancelled" ? (
//                                   "Order has been cancelled. This order has closed. "
//                                 ) : (
//                                   <>
//                                     {t("Change Status")}
//                                     <Box sx={{ mt: 3 }}>
//                                       <FormControl fullWidth>
//                                         <InputLabel id="demo-simple-select-label">
//                                           Order Status
//                                         </InputLabel>
//                                         <Select
//                                           labelId="demo-simple-select-label"
//                                           id="demo-simple-select"
//                                           value={status}
//                                           label="Order Status"
//                                           onChange={(e) =>
//                                             setStatus(e.target.value)
//                                           }
//                                         >
//                                           {order.status[
//                                             order.status.length - 1
//                                           ] === "Preparing for shipment" ? (
//                                             <MenuItem value={"Order confirmed"}>
//                                               {t("Order confirmed")}
//                                             </MenuItem>
//                                           ) : null}

//                                           {order.status[
//                                             order.status.length - 1
//                                           ] === "Order confirmed" ||
//                                           order.status[
//                                             order.status.length - 1
//                                           ] === "Preparing for shipment" ? (
//                                             <MenuItem value={"Order delayed"}>
//                                               {t("Order delayed")}
//                                             </MenuItem>
//                                           ) : null}

//                                           {order.status[
//                                             order.status.length - 1
//                                           ] === "Preparing for shipment" ||
//                                           order.status[
//                                             order.status.length - 1
//                                           ] === "Order confirmed" ||
//                                           order.status[
//                                             order.status.length - 1
//                                           ] === "Order delayed" ? (
//                                             <MenuItem value={"Order cancelled"}>
//                                               {t("Order cancelled")}
//                                             </MenuItem>
//                                           ) : null}

//                                           <MenuItem value={"Order shipped"}>
//                                             {t("Order shipped")}
//                                           </MenuItem>
//                                         </Select>
//                                       </FormControl>

//                                       {status === "Order shipped" ? (
//                                         <Box>
//                                           <Box sx={{ color: "gray", mt: 1 }}>
//                                             {t(
//                                               "After submitting, the system will send an automatic email to the user with this notification."
//                                             )}{" "}
//                                           </Box>
//                                           <Box
//                                             sx={{
//                                               position: "relative",
//                                               top: "+10px",
//                                             }}
//                                           >
//                                             {t("Shipping2")} #1
//                                           </Box>
//                                           <FormControl
//                                             variant="filled"
//                                             fullWidth
//                                             sx={{ mt: 2 }}
//                                           >
//                                             <InputLabel id="demo-simple-select-label">
//                                               Shipping Provider
//                                             </InputLabel>
//                                             <Select
//                                               labelId="demo-simple-select-label"
//                                               id="demo-simple-select"
//                                               value={shipMethod1}
//                                               label="Provider"
//                                               onChange={(e) =>
//                                                 setShipMethod1(e.target.value)
//                                               }
//                                             >
//                                               <MenuItem value={"FEDEX"}>
//                                                 FEDEX
//                                               </MenuItem>
//                                               <MenuItem value={"USPS"}>
//                                                 USPS
//                                               </MenuItem>
//                                               <MenuItem value={"UPS"}>
//                                                 UPS
//                                               </MenuItem>
//                                               <MenuItem value={"DHL"}>
//                                                 DHL
//                                               </MenuItem>
//                                             </Select>
//                                           </FormControl>
//                                           <TextField
//                                             variant="filled"
//                                             sx={{ mt: 2, width: 1 }}
//                                             label="Enter Tracking Number"
//                                             value={shipNum1}
//                                             onChange={(e) =>
//                                               setShipNum1(e.target.value)
//                                             }
//                                           />
//                                           <Box>
//                                             <Box
//                                               sx={{
//                                                 position: "relative",
//                                                 top: "+10px",
//                                               }}
//                                             >
//                                               {t("Shipping2")} #2
//                                             </Box>
//                                             <FormControl
//                                               variant="filled"
//                                               fullWidth
//                                               sx={{ mt: 2 }}
//                                             >
//                                               <InputLabel id="demo-simple-select-label">
//                                                 Shipping Provider
//                                               </InputLabel>
//                                               <Select
//                                                 labelId="demo-simple-select-label"
//                                                 id="demo-simple-select"
//                                                 value={shipMethod2}
//                                                 label="Provider"
//                                                 onChange={(e) =>
//                                                   setShipMethod2(e.target.value)
//                                                 }
//                                               >
//                                                 <MenuItem value={"FEDEX"}>
//                                                   FEDEX
//                                                 </MenuItem>
//                                                 <MenuItem value={"USPS"}>
//                                                   USPS
//                                                 </MenuItem>
//                                                 <MenuItem value={"UPS"}>
//                                                   UPS
//                                                 </MenuItem>
//                                                 <MenuItem value={"DHL"}>
//                                                   DHL
//                                                 </MenuItem>
//                                               </Select>
//                                             </FormControl>
//                                             {/* <Checkbox {...label} defaultChecked /> */}
//                                             <TextField
//                                               variant="filled"
//                                               sx={{ mt: 2, width: 1 }}
//                                               label="Enter Tracking Number"
//                                               value={shipNum2}
//                                               onChange={(e) =>
//                                                 setShipNum2(e.target.value)
//                                               }
//                                             />
//                                           </Box>
//                                         </Box>
//                                       ) : null}
//                                       <button
//                                         onClick={updateShippingInfo}
//                                         style={{ marginTop: "20px" }}
//                                         className="custom_btn"
//                                       >
//                                         Submit
//                                       </button>
//                                     </Box>
//                                   </>
//                                 )}
//                                 {/* & Update Tracking Number */}
//                               </Box>
//                               <AdminSentEmailsFromOrder orderId={id} />
//                               {/* <Box>
//                         <Box sx={{ position: "relative", top: "+10px" }}>
//                           Shipping #1
//                         </Box>
//                         <FormControl variant="filled" fullWidth sx={{ mt: 2 }}>
//                           <InputLabel id="demo-simple-select-label">
//                             Shipping Provider
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-label"
//                             id="demo-simple-select"
//                             value={shipMethod1}
//                             label="Provider"
//                             onChange={(e) => setShipMethod1(e.target.value)}
//                           >
//                             <MenuItem value={"FEDEX"}>FEDEX</MenuItem>
//                             <MenuItem value={"USPS"}>USPS</MenuItem>
//                             <MenuItem value={"UPS"}>UPS</MenuItem>
//                             <MenuItem value={"DHL"}>DHL</MenuItem>
//                           </Select>
//                         </FormControl>
//                         <TextField
//                           variant="filled"
//                           sx={{ mt: 2, width: 1 }}
//                           label="Enter Tracking Number"
//                           value={shipNum1}
//                           onChange={(e) => setShipNum1(e.target.value)}
//                         />
//                       </Box> */}
//                               {/* <Box>
//                         <Box sx={{ position: "relative", top: "+10px" }}>
//                           Shipping #2
//                         </Box>
//                         <FormControl variant="filled" fullWidth sx={{ mt: 2 }}>
//                           <InputLabel id="demo-simple-select-label">
//                             Shipping Provider
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-label"
//                             id="demo-simple-select"
//                             value={shipMethod2}
//                             label="Provider"
//                             onChange={(e) => setShipMethod2(e.target.value)}
//                           >
//                             <MenuItem value={"FEDEX"}>FEDEX</MenuItem>
//                             <MenuItem value={"USPS"}>USPS</MenuItem>
//                             <MenuItem value={"UPS"}>UPS</MenuItem>
//                             <MenuItem value={"DHL"}>DHL</MenuItem>
//                           </Select>
//                         </FormControl>
//                         <TextField
//                           variant="filled"
//                           sx={{ mt: 2, width: 1 }}
//                           label="Enter Tracking Number"
//                           value={shipNum2}
//                           onChange={(e) => setShipNum2(e.target.value)}
//                         />
//                       </Box> */}
//                               {/* <button
//                         onClick={() => changeStep(2)}
//                         className="custom_btn"
//                         style={{ marginTop: "20px" }}
//                       >
//                         Update
//                       </button> */}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       );
//                     })}
//                   </Box>
//                 </Grid>
//               </Grid>
//               {/* End of Content */}
//             </Box>
//           </Grid>
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// };

// export default AdminDashboard;
// // users

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import { useTranslation } from "react-i18next";

import { db, collection, doc, getDoc, addDoc, updateDoc } from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import { useParams } from "react-router-dom";
import AdminSentEmailsFromOrder from "./AdminSentEmailsFromOrder";

import CurrencyFormat from "react-currency-format";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HashLink } from "react-router-hash-link";
import AddNote from "./AddNote";
import AdminCheck from "./AdminCheck";
import emailjs from "@emailjs/browser";

const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  let { id } = useParams();

  let navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState(null);
  const [step, setStep] = useState(2);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [status, setStatus] = useState(null);
  const [reason, setReason] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [delayReason, setDelayReason] = useState(null);
  const [totalQuantity, setTotalQuantity] = useState(0);
  console.log("totalQuantity", totalQuantity);

  const getOrders = async () => {
    setOrders([]);
    const docRef = doc(db, "US_orders", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.data()?.status !== undefined) setStatus(docSnap.data().status);
    setOrder(docSnap.data());
    console.log("docSnap.data()", docSnap.data());

    let numOfQuantity = 0;

    if (docSnap.data().basket !== undefined && docSnap.data().basket) {
      JSON.parse(docSnap.data().basket).map((item) => {
        console.log("item", item);
        numOfQuantity = numOfQuantity + item.quantity;
      });
    }
    setTotalQuantity(numOfQuantity);

    if (docSnap.exists()) {
      if (docSnap.data().user_uid) {
        const docRef2 = doc(db, "users", docSnap.data().user_uid);
        getDoc(docRef2).then(async (res) => {
          console.log(res.data());

          if (res.data().firstname && res.data().lastname) {
            setOrders((old) =>
              old.concat({
                ...docSnap.data(),
                id: docSnap.data().id,
                firstname: res.data().firstname,
                lastname: res.data().lastname,
              })
            );
          } else {
            setOrders((old) =>
              old.concat({
                ...docSnap.data(),
                id: docSnap.data().id,
              })
            );
          }
        });
      }
    } else {
      navigate("/admin/orders");
    }
  };

  useEffect(() => {
    setTimeout(() => {
      getOrders();
    }, 100);
  }, []);

  console.log(orders);

  console.log(step);
  console.log("status", status); // selected action
  console.log("order.status", order?.status);

  useEffect(() => {
    setStep(1);
  }, []);

  const changeStep = (num) => {
    setStep(num);
  };

  const orderConfirmed = async (orderId) => {
    try {
      const ref = doc(db, "US_orders", orderId);

      await updateDoc(
        ref,
        {
          status: [...order.status, "Order confirmed"],
        },
        { merge: true }
      );

      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 발주확인되었습니다",
        orderId: orderId,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_ub6tfci",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
      changeStep(3);
      alert(
        "발주확인이 완료 되었습니다! 상태 변경이 완료되고 손님에게 이메일을 전송했습니다."
      );

      handleClose();
      changeStep(1);
    } catch (err) {}
  };

  const orderDelayed = async (orderId) => {
    console.log("############### orderDelayed orderId", orderId);
    try {
      const ref = doc(db, "US_orders", orderId);
      await updateDoc(
        ref,
        {
          status: [...order.status, "Order delayed"],
        },
        { merge: true }
      );
      alert("배송 지연이 완료 되었습니다!");

      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 지연되었습니다",
        orderId: orderId,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_ub6tfci",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
    } catch (err) {
      alert("There is an error when processing. Please try again later.");
    }
  };
  const orderCancelled = async (orderId) => {
    try {
      const ref = doc(db, "US_orders", orderId);
      await updateDoc(
        ref,
        {
          status: [...order.status, "Order cancelled"],
        },
        { merge: true }
      );
      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 주문취소되었습니다",
        orderId: orderId,
      };
      emailjs.send(
        "service_66owpwy",
        "template_ub6tfci",
        templateParams1,
        "user_7Zql27tiMF2NZkNx1LGdg"
      );
      alert("주문취소가 완료 되었습니다!");
      changeStep(3);
      setTimeout(() => {
        handleClose();
        changeStep(1);
      }, 2000);
      window.location.reload(false);
    } catch (error) {
      alert("There is an error when processing. Please try again later.");
    }
  };

  const orderShipped = async (orderId, tracking) => {
    try {
      console.log("tracking", tracking);
      const ref = doc(db, "KO_orders", orderId);
      await updateDoc(
        ref,
        {
          status: [...order.status, "Order shipped"],
          tracking: tracking,
        },
        { merge: true }
      );
      alert("주문 발송으로 상태를 변경했습니다.");
      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 발송완료되었습니다",
        orderId: orderId,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_ub6tfci",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
      changeStep(3);
      setTimeout(() => {
        handleClose();
        changeStep(1);
      }, 2000);
      // window.location.reload(false);
    } catch (error) {
      alert("There is an error when processing. Please try again later.");
    }
  };

  const updateShippingInfo = async () => {
    // 발주확인

    if (status === "Order confirmed") {
      orderConfirmed(id);
    } else if (status === "Order delayed") {
      orderDelayed(id);
    } else if (status === "Order cancelled") {
      orderCancelled(id);
    }
    getOrders();
  };

  const handleOrderShipped = (event) => {
    event.preventDefault();

    let num = Math.ceil(totalQuantity / 20);
    let tracking = [];
    for (let i = 0; i < num * 2; i = i + 2) {
      if (
        event.target[i].value.length > 0 &&
        event.target[i + 1].value.length > 0
      ) {
        tracking.push({
          company: event.target[i].value,
          tracking: event.target[i + 1].value,
        });
      }
    }
    console.log("Trackings...", tracking);
    orderShipped(id, tracking);
  };

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9.5} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%" }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px", pl: 5, fontWeight: 600 }}>
                  회원 주문 상세 페이지
                </Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  View Details Stats
                </Box> */}
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "13px",
                }}
              ></Box>
              <Grid container>
                <Grid item md={12} sm={12} xs={12} sx={{ pb: 10 }}>
                  <Box
                    sx={{
                      py: 2,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      px: 4,
                    }}
                  >
                    {orders.map((order, idx) => {
                      console.log("order", order);
                      return (
                        <Box
                          key={idx}
                          className="textBox"
                          style={{
                            marginBottom: "20px",
                            width: "100%",
                            backgroundColor: "white",
                          }}
                        >
                          <Box sx={{ color: "black", fontSize: "14px" }}>
                            <Box
                              sx={{
                                display: "flex",
                                paddingTop: "10px",
                                alignItems: "center",
                              }}
                            ></Box>
                          </Box>
                          <Box>
                            <Typography
                              id="transition-modal-title"
                              component={"span"}
                              variant={"body2"}
                              style={{ fontSize: "15px", fontWeight: 600 }}
                            >
                              주문 내용
                            </Typography>
                            <Typography
                              id="transition-modal-description"
                              sx={{
                                mt: 2,
                                color: "black",
                                lineHeight: "1.9em",
                                fontSize: "13px",
                              }}
                            >
                              <Box>
                                <span style={{}}>
                                  <span className="normal">주문 번호</span>:{" "}
                                  {id},
                                </span>
                                <span>
                                  {" "}
                                  <span className="normal">
                                    주문 날짜
                                  </span>:{" "}
                                  {order?.created &&
                                    order?.created
                                      ?.toDate()
                                      .toLocaleDateString("fr-CA", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })}{" "}
                                  {order?.created &&
                                    order?.created
                                      ?.toDate()
                                      .toLocaleTimeString("ko-KR")}
                                </span>
                              </Box>
                              <div style={{}}>
                                <span className="normal">고객 이름</span>:&nbsp;
                                <span>
                                  {order?.lastname} {order?.firstname}
                                </span>{" "}
                              </div>{" "}
                              <Box>
                                <span className="normal">전화번호</span>:{" "}
                                {order?.phone}
                              </Box>
                              <span>
                                <span className="normal">배송지 주소</span>:{" "}
                              </span>
                              <span
                                style={{
                                  color: "#153a5a",
                                  fontWeight: 800,
                                  textDecoration: "underline",
                                }}
                              >
                                {order?.address_lastname}&nbsp;
                                {order?.address_firstname}
                              </span>
                              &nbsp;
                              {order?.address_address}&nbsp;
                              {order?.address_apt}&nbsp;
                              {order?.address_city}&nbsp;
                              {order?.address_state}&nbsp;
                              {order?.address_zipcode}
                              <br />
                              <span className="normal">배송비:</span> $
                              {order?.shippingPrice}
                              <br />
                              <span className="normal">총 가격: </span>
                              <CurrencyFormat
                                decimalScale={2}
                                value={order?.finalPrice}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                              <br />
                              {/* <Box
                                sx={{
                                  mt: 2,
                                  border: "1px solid lightgray",
                                  px: 3,
                                  py: 2,
                                }}
                              >
                                <Box sx={{ fontWeight: 800 }}>
                                  결제 상태
                                  <span
                                    style={{
                                      color: "gray",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    (입금을 확인하셨으면 '발주확인'을
                                    눌러주세요.)
                                  </span>
                                </Box>
                                <Box sx={{ color: "#153a5a" }}>
                                  입금 은행: {order?.payment_status?.bank},
                                  입금자명:{" "}
                                  {order?.payment_status?.customer_name}
                                </Box>
                              </Box> */}
                              <br />
                              <Box>
                                주문 상태:{" "}
                                <span style={{ color: "blue" }}>
                                  {t(order?.status[order.status.length - 1])}
                                </span>{" "}
                                <Box
                                  sx={{
                                    fontSize: "13px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    paddingBottom: "10px",
                                    marginTop: "10px",
                                  }}
                                >
                                  <Box>
                                    {order?.lastname} {order?.firstname}{" "}
                                    {order?.user_uid && (
                                      <HashLink
                                        className="pink_link"
                                        style={{ textDecoration: "non" }}
                                        to={"/admin/user/" + order?.user_uid}
                                      >
                                        [유저 정보 보기]
                                      </HashLink>
                                    )}
                                    <a
                                      target={"_blank"}
                                      className="pink_link"
                                      href={"mailto:" + order.email}
                                    >
                                      [이메일 보내기]
                                    </a>
                                  </Box>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  fontSize: "13px",
                                  pt: 5,
                                  color: "#757575",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  flex: 1,
                                }}
                              >
                                <Box sx={{ pl: 5 }}>
                                  <Box sx={{ color: "black", pb: 2 }}>
                                    주문 내역
                                  </Box>
                                  {JSON.parse(order.basket).map((item, idx) => (
                                    <Box key={idx} sx={{ color: "black" }}>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={item.image}
                                          alt=""
                                          width="60"
                                        />
                                        <Box sx={{ pl: 2 }}>
                                          {item.quantity}x{" "}
                                          <span style={{}}>{t(item.name)}</span>
                                        </Box>
                                      </Box>
                                    </Box>
                                  ))}
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    minWidth: "200px",
                                    pr: 8,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      fontSize: "13px",
                                      color: "black",
                                      pb: 2,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <CurrencyFormat
                                      value={order.finalPrice}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"$"}
                                    />
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Box>{t("Subtotal")}</Box>
                                    <Box>
                                      <CurrencyFormat
                                        decimalScale={2}
                                        value={order.subtotal}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      pb: 1,
                                    }}
                                  >
                                    <Box>배송비</Box>
                                    <Box>
                                      <CurrencyFormat
                                        decimalScale={2}
                                        value={order.shippingPrice}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                      />{" "}
                                    </Box>
                                  </Box>

                                  <Box
                                    sx={{
                                      borderTop: "1px solid lightgray",
                                      pt: 1,
                                    }}
                                  ></Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Box>{t("Total")}</Box>
                                    <Box>
                                      <CurrencyFormat
                                        decimalScale={2}
                                        value={order.finalPrice}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  pt: 2,
                                  p: 3,
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  mr: 2,
                                  ml: 1,
                                  mt: 3,
                                }}
                              >
                                <InventoryOutlinedIcon
                                  sx={{
                                    position: "relative",
                                    top: "+6px",
                                    color: "gray",
                                  }}
                                />{" "}
                                {order.status[order.status.length - 1] ===
                                "Order cancelled" ? (
                                  t(
                                    "Order has been cancelled. This order has closed. "
                                  )
                                ) : order.status[order.status.length - 1] !==
                                  "Order shipped" ? (
                                  <>
                                    <span style={{ fontWeight: "bold" }}>
                                      {t("Change Status")}
                                    </span>
                                    <Box sx={{ mt: 3 }}>
                                      <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                          {t("Order Status")}
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={status}
                                          label="Order Status"
                                          onChange={(e) =>
                                            setStatus(e.target.value)
                                          }
                                          sx={{
                                            width: "300px",
                                            backgroundColor: "white",
                                          }}
                                        >
                                          {order.status[
                                            order.status.length - 1
                                          ] === "Preparing for shipment" ? (
                                            <MenuItem value={"Order confirmed"}>
                                              {t("Order confirmed")}
                                            </MenuItem>
                                          ) : null}

                                          {order.status[
                                            order.status.length - 1
                                          ] === "Order confirmed" ||
                                          order.status[
                                            order.status.length - 1
                                          ] === "Preparing for shipment" ? (
                                            <MenuItem value={"Order delayed"}>
                                              {t("Order delayed")}
                                            </MenuItem>
                                          ) : null}

                                          {order.status[
                                            order.status.length - 1
                                          ] === "Preparing for shipment" ||
                                          order.status[
                                            order.status.length - 1
                                          ] === "Order confirmed" ||
                                          order.status[
                                            order.status.length - 1
                                          ] === "Order delayed" ? (
                                            <MenuItem value={"Order cancelled"}>
                                              {t("Order cancelled")}
                                            </MenuItem>
                                          ) : null}

                                          <MenuItem value={"Order shipped"}>
                                            {t("Order shipped")}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>

                                      {status === "Order delayed" ? (
                                        <Box>
                                          <div>
                                            <Box
                                              sx={{
                                                color: "#283593",
                                                pb: 2,
                                                pt: 2,
                                              }}
                                            >
                                              발송 지연처리는 '1회'만
                                              가능합니다. 이메일을 보내실때 발송
                                              기한을 고객에게 보낼수있습니다.
                                            </Box>
                                            <Box sx={{ minWidth: 120 }}>
                                              <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">
                                                  {t("Reason of the delay")}
                                                </InputLabel>
                                                <Select
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={reason}
                                                  label="Age"
                                                  onChange={(e) =>
                                                    setReason(e.target.value)
                                                  }
                                                  sx={{
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  <MenuItem
                                                    value={
                                                      "Preparing for the product"
                                                    }
                                                  >
                                                    {t(
                                                      "Preparing for the product"
                                                    )}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Customer request"}
                                                  >
                                                    {t("Customer request")}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Custom order"}
                                                  >
                                                    {t("Custom order")}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Scheduled shipment"}
                                                  >
                                                    {t("Scheduled shipment")}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Oversea shipment"}
                                                  >
                                                    {t("Oversea shipment")}
                                                  </MenuItem>
                                                  <MenuItem value={"Other"}>
                                                    {t("Other")}
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  width: 1,
                                                  alignItems: "center",
                                                  pt: 2,
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    width: 1 / 2,
                                                    paddingTop: "9px",
                                                  }}
                                                >
                                                  발송 기한
                                                </Box>
                                                <DatePicker
                                                  selected={startDate}
                                                  onChange={(date) =>
                                                    setStartDate(date)
                                                  }
                                                />
                                              </Box>
                                              <Box
                                                sx={{
                                                  width: 1,
                                                  pt: 2,
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    width: 1 / 2,
                                                    paddingTop: "9px",
                                                    mb: 2,
                                                  }}
                                                >
                                                  발송 지연 상세 사유
                                                  (옵션입니다)
                                                </Box>
                                                <TextField
                                                  value={delayReason}
                                                  onChange={(e) =>
                                                    setDelayReason(
                                                      e.target.value
                                                    )
                                                  }
                                                  multiline
                                                  rows={3}
                                                  sx={{
                                                    width: 1,
                                                    backgroundColor: "white",
                                                  }}
                                                />
                                              </Box>
                                            </Box>
                                          </div>
                                        </Box>
                                      ) : null}

                                      {status === "Order shipped" ? (
                                        <Box>
                                          <Box
                                            sx={{
                                              color: "gray",
                                              mt: 1,
                                              fontSize: "13px",
                                            }}
                                          >
                                            {t(
                                              "After submitting, the system will send an automatic email to the user with this notification."
                                            )}{" "}
                                          </Box>

                                          <form onSubmit={handleOrderShipped}>
                                            <Box>
                                              배송 업체를 선택하고 송장 번호를
                                              입력해주세요
                                            </Box>
                                            {Array.from(
                                              Array(
                                                Math.ceil(totalQuantity / 20)
                                              ),
                                              (e, i) => {
                                                return (
                                                  <Box
                                                    sx={{
                                                      mt: 1,
                                                    }}
                                                  >
                                                    <Box
                                                      sx={{
                                                        position: "relative",
                                                        top: "+1px",
                                                        color: "#153a5a",
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {t("Shipping2")} {i + 1}
                                                    </Box>
                                                    <Box
                                                      sx={{ display: "flex" }}
                                                    >
                                                      <select
                                                        style={{
                                                          width: "200px",
                                                          height: "40px",
                                                          border:
                                                            "1px solid lightgray",
                                                          paddingLeft: "5px",
                                                        }}
                                                      >
                                                        <option
                                                          value={"CJ대한통운"}
                                                        >
                                                          CJ대한통운
                                                        </option>
                                                        <option
                                                          value={
                                                            "롯데글로벌로지스"
                                                          }
                                                        >
                                                          롯데글로벌로지스
                                                        </option>
                                                        <option value={"한진"}>
                                                          한진
                                                        </option>
                                                        <option
                                                          value={"우체국택배"}
                                                        >
                                                          우체국택배
                                                        </option>
                                                        <option
                                                          value={"로젠택배"}
                                                        >
                                                          로젠택배
                                                        </option>
                                                        <option
                                                          value={
                                                            "CU 편의점택배"
                                                          }
                                                        >
                                                          CU 편의점택배
                                                        </option>
                                                      </select>
                                                      <input
                                                        type={"text"}
                                                        style={{
                                                          width: "300px",
                                                          height: "40px",
                                                          border:
                                                            "1px solid lightgray",
                                                          borderLeft: "none",
                                                          paddingLeft: "15px",
                                                        }}
                                                      />
                                                    </Box>
                                                  </Box>
                                                );
                                              }
                                            )}
                                            <button
                                              style={{
                                                marginTop: "20px",
                                                width: "300px",
                                              }}
                                              className="custom_btn"
                                            >
                                              주문 발송으로 변경하기
                                            </button>
                                          </form>
                                        </Box>
                                      ) : null}
                                      <button
                                        onClick={updateShippingInfo}
                                        style={{
                                          marginTop: "20px",
                                          width: "300px",
                                          display:
                                            status === "Order shipped"
                                              ? "none"
                                              : "inline",
                                        }}
                                        className="custom_btn"
                                      >
                                        {t("Submit")}
                                      </button>
                                    </Box>
                                  </>
                                ) : (
                                  <span style={{ fontWeight: 600 }}>
                                    이 주문은 '주문 발송' 되었습니다
                                    <Box
                                      sx={{
                                        fontWeight: 200,
                                        fontSize: "13px",
                                        pt: 2,
                                      }}
                                    >
                                      주문 운송장 정보:
                                      {order.tracking &&
                                        order.tracking.map((track) => {
                                          return (
                                            <Box>
                                              택배 회사:{" "}
                                              <span style={{ fontWeight: 600 }}>
                                                {track.company}
                                              </span>
                                              , 운송장 번호:{" "}
                                              <span style={{ fontWeight: 600 }}>
                                                {track.tracking}
                                              </span>
                                            </Box>
                                          );
                                          console.log(track);
                                        })}
                                    </Box>
                                  </span>
                                )}
                                {/* & Update Tracking Number */}
                              </Box>
                              <AddNote currentLocation={"US"} orderId={id} />
                              {/* <AdminSentEmailsFromOrder orderId={id} /> */}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
